// @ts-nocheck
import { MODULE_ACL } from './constant';
import { isAclModuleOptionsRelevant } from './aclModuleOptionsAccess';
import { AGENT_EDIT_OPTION_DEFS } from './agentAcl';
import { CALL_GROUP_EDIT_OPTION_DEFS } from './callGroupAcl';
import { IVR_NODE_OPTION_DEFS } from './ivrAcl';
import { DISPOSITION_TIMING_OPTION_DEFS } from './dispositionFormsAcl';
import { VOICEMAIL_ACL_OPTION } from './callCentreVoicemailAcl';
import { TRANSCRIPTION_ACL_OPTION } from './callCentreTranscriptionAcl';
import { CUSTOM_LEADS_ACL_OPTION } from './agentLeadsQuota';
import { EMAIL_VERIFICATION_ACL_OPTION } from './userEmailVerificationAcl';
import { CHANGE_ASSETS_VISIBILITY } from './companyAssetsVisibilityAcl';
import { VOICE_TYPE_OPTIONS } from './voiceLibraryAcl';
import { TTS_OPERATOR_OMNI } from './ttsAcl';
import { isAiAgentDescLimitConfigured } from './aiAgentAcl';

const EDIT_OPTION_DEFS_BY_MODULE = {
  [MODULE_ACL.AGENTS]: AGENT_EDIT_OPTION_DEFS,
  [MODULE_ACL.CALL_GROUP]: CALL_GROUP_EDIT_OPTION_DEFS,
  [MODULE_ACL.IVR]: IVR_NODE_OPTION_DEFS,
  [MODULE_ACL.DISPOSITION_FORMS]: DISPOSITION_TIMING_OPTION_DEFS,
  [MODULE_ACL.CALL_CENTRE]: [
    { value: VOICEMAIL_ACL_OPTION, label: 'Voicemail' },
    { value: TRANSCRIPTION_ACL_OPTION, label: 'Transcription' },
  ],
  [MODULE_ACL.AGENT_LEADS]: [
    { value: CUSTOM_LEADS_ACL_OPTION, label: 'Custom Leads' },
  ],
  [MODULE_ACL.USERS]: [
    { value: EMAIL_VERIFICATION_ACL_OPTION, label: 'Email verification required' },
  ],
  [MODULE_ACL.COMPANY]: [
    { value: CHANGE_ASSETS_VISIBILITY, label: 'Change assets visibility' },
  ],
};

const asList = (value) => (Array.isArray(value) ? value.map((v) => String(v).trim()) : []);

const labelsFor = (defs, stored) => {
  const picked = asList(stored);
  return defs.filter((def) => picked.includes(def.value)).map((def) => def.label);
};

export function getAclModuleOptionLabels(moduleName, moduleEntry) {
  if (!moduleEntry || !isAclModuleOptionsRelevant(moduleEntry)) return [];

  const defs = EDIT_OPTION_DEFS_BY_MODULE[moduleName];
  if (defs) return labelsFor(defs, moduleEntry.edit_options);

  if (moduleName === MODULE_ACL.VOICE_PLANS) {
    return asList(moduleEntry.plan_directions).filter(Boolean);
  }

  if (moduleName === MODULE_ACL.VOICE_LIBRARY) {
    const types = labelsFor(VOICE_TYPE_OPTIONS, moduleEntry.voice_types);
    const languages = asList(moduleEntry.languages).filter(Boolean);
    return [
      ...types.map((t) => `Type: ${t}`),
      ...languages.map((l) => `Language: ${l}`),
    ];
  }

  if (moduleName === MODULE_ACL.TTS) {
    const operator = moduleEntry.tts_operator;
    if (!operator) return [];
    return [operator === TTS_OPERATOR_OMNI ? 'OMNI VOICE' : 'SARVAM'];
  }

  if (moduleName === MODULE_ACL.AI_AGENT) {
    if (!isAiAgentDescLimitConfigured(moduleEntry)) return [];
    return [`Description limit: ${moduleEntry.description_char_limit} chars`];
  }

  return [];
}

export function formatAclModuleOptionLabels(moduleName, moduleEntry, fallback = '—') {
  const labels = getAclModuleOptionLabels(moduleName, moduleEntry);
  return labels.length ? labels.join(', ') : fallback;
}
